import { IApiError } from '@/models/apiError.model';
import { IPrice, IAppraiserPrice, IPhotoShootingPrice, ISettlementData } from '@/models/prices.model';

export const PRICES_SLICE_NAME = 'prices';

export interface PricesState {
  price: IPrice | null;
  settlementData: ISettlementData | null;
  appraisePrices: IAppraiserPrice[] | null;
  photoShootingPrices: IPhotoShootingPrice[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: PricesState = {
  price: null,
  photoShootingPrices: null,
  appraisePrices: null,
  settlementData: null,
  isLoading: false,
  error: null,
};
